import { t } from "@bookingcom/lingojs-core";
import { filterFeaturesByPriority, mergeFeatures } from "./brandedFares.js";
export const SEATS_BASIC_AND_PREMIUM_SELLABLE = [
    { featureName: "PREMIUM_SEAT", availability: "SELLABLE" },
    { featureName: "BASIC_SEAT", availability: "SELLABLE" }
];
export const SEAT_PRIORITY = [
    { featureName: "PREMIUM_SEAT", availability: "INCLUDED" },
    { featureName: "BASIC_SEAT", availability: "INCLUDED" },
    { featureName: "PREMIUM_OR_BASIC_SEAT", availability: "SELLABLE" },
    ...SEATS_BASIC_AND_PREMIUM_SELLABLE,
    { featureName: "PRE_RESERVED_SEAT_ASSIGNMENT", availability: "INCLUDED" },
    { featureName: "PRE_RESERVED_SEAT_ASSIGNMENT", availability: "SELLABLE" },
    { featureName: "PREMIUM_SEAT", availability: "NOT_INCLUDED" },
    { featureName: "BASIC_SEAT", availability: "NOT_INCLUDED" },
    { featureName: "PRE_RESERVED_SEAT_ASSIGNMENT", availability: "NOT_INCLUDED" }
];
export const clarifySeatsFeatures = (features, i18n) => {
    features = mergeFeatures(features, SEATS_BASIC_AND_PREMIUM_SELLABLE, createSellablePremiumOrBasicFeature(i18n));
    return filterFeaturesByPriority(features, SEAT_PRIORITY);
};
export const isIncludedOrSellableSeat = (feature) => feature.category === "SEATS" && feature.availability !== "NOT_INCLUDED";
export const overrideSeatSelectedAtAirlineCopy = (feature, i18n) => {
    if (feature.category !== "SEATS")
        return feature;
    if (feature.availability === "INCLUDED")
        return { ...feature, label: i18n.trans(t("flights_checknpay_bf_modal_seats_included")) };
    if (feature.availability === "SELLABLE")
        return { ...feature, label: i18n.trans(t("flights_checknpay_bf_modal_seats_sellable")) };
    return feature;
};
const createSellablePremiumOrBasicFeature = (i18n) => ({
    featureName: "PREMIUM_OR_BASIC_SEAT",
    availability: "SELLABLE",
    category: "SEATS",
    code: "",
    label: i18n.trans(t("flights_bf_seats_sellable")),
    content: {},
    priority: 0
});
